"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _flatten2 = _interopRequireDefault(require("lodash/flatten"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
require("moment-timezone");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _prepareSubmitData = _interopRequireDefault(require("./prepareSubmitData.js"));
var _questProjectSubmit = _interopRequireDefault(require("./questProjectSubmit.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
function notifyNoKeyErrors(fieldTypes, errors) {
  var errorKeys = Object.keys(errors);
  var reduxKeys = fieldTypes.map(function (f) {
    return f.reduxFieldHandle;
  });
  errorKeys.forEach(function (key) {
    if (!reduxKeys.includes(key)) {
      (0, _cccisdNotification["default"])({
        duration: -1,
        message: (0, _flatten2["default"])(errors[key], true).join(', '),
        type: 'danger'
      });
    }
  });
}
var _default = exports["default"] = function _default(_ref) {
  var _ref$row = _ref.row,
    row = _ref$row === void 0 ? {} : _ref$row,
    values = _ref.values,
    routes = _ref.routes,
    fieldTypes = _ref.fieldTypes,
    hasMatchedUser = _ref.hasMatchedUser;
  var operation = (0, _isEmpty2["default"])(row) ? 'create' : 'edit';
  var route = routes[operation];
  var data = (0, _prepareSubmitData["default"])(values, fieldTypes, hasMatchedUser);
  if (operation === 'edit') {
    // we will only have route params on PUTs
    var boilerplateRouteParams = {};

    // we assume that all variables are from row prop
    Object.keys(route.params).forEach(function (param) {
      boilerplateRouteParams[param] = (0, _get2["default"])(row, route.params[param]);
    });
    data.pawnHash = row['pawn.pawnHash'];
    return new Promise(function (resolve, reject) {
      _cccisdAxios["default"].put(Boilerplate.route(route.name, boilerplateRouteParams), data).then(function (response) {
        if (response.data && response.data.status === 'error') {
          notifyNoKeyErrors(fieldTypes, response.data.errors);
          reject(response.data.errors);
        } else {
          resolve();
        }
      });
    });
  }
  return new Promise(function (resolve, reject) {
    _cccisdAxios["default"].post(Boilerplate.route(route.name), data).then(function (response) {
      if (response.data && response.data.status === 'error') {
        notifyNoKeyErrors(fieldTypes, response.data.errors);
        reject(response.data.errors);
      } else {
        (0, _questProjectSubmit["default"])(data, response);
        resolve();
      }
    });
  });
};